import * as React from "react";
import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Chip,
  Avatar,
} from "@mui/material";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { tableCellClasses } from "@mui/material/TableCell";
import { Check as MUICheck, Close as MUIClose } from "@mui/icons-material";

import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const Check = styled(MUICheck)`
  color: ${colors.lightGreen};
  border-radius: 5px;
  border: 3px solid;
  font-size: x-large;
  margin-top: 5px;
`;

const Close = styled(MUIClose)`
  color: ${colors.primaryButton};
  border-radius: 5px;
  border: 3px solid;
  font-size: x-large;
  margin-top: 5px;
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
    fontSize: "11px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
    fontSize: "12px",
  },

  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },

  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ brands, setBrandStatus }) {
  const navigate = useNavigate();

  function handleBrandNavigation(brandID) {
    navigate(pages.unverifiedPageDetails.route + "?brandID=" + brandID);
  }

  return (
    <TableContainer
      sx={{ maxHeight: "90%", borderRadius: "10px" }}
      component={Paper}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead style={{ height: "65px" }}>
          <TableRow>
            <StyledTableCell />

            <StyledTableCell>Brand Name</StyledTableCell>
            <StyledTableCell>Brand Status</StyledTableCell>
            <StyledTableCell>Brand Detail</StyledTableCell>
            <StyledTableCell>Company Detail</StyledTableCell>
            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {brands.map((brand) => (
            <StyledTableRow>
              <Fragment>
                <StyledTableCell component="th" scope="row">
                  <Avatar
                    onClick={() => handleBrandNavigation(brand.brand_id)}
                    src={brand.logo}
                    style={{ height: "40px", width: "40px", cursor: "pointer" }}
                  />
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {brand.brand_name.replace(/_/g, " ") || "-"}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  <StatusChip brand={brand} />
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  <Check
                    sx={{
                      marginLeft: "35px",
                    }}
                  />
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {brand.is_company_detail_filled === 1 ? (
                    <Check
                      sx={{
                        marginLeft: "45px",
                        color: colors.lightGreen,
                      }}
                    />
                  ) : (
                    <Close
                      sx={{
                        marginLeft: "45px",
                        color: colors.yellow,
                      }}
                    />
                  )}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  <Tooltip title="View Brand">
                    <Icon>
                      <CgEye
                        onClick={() => handleBrandNavigation(brand.brand_id)}
                        style={{ height: "20px", width: "20px" }}
                      />
                    </Icon>
                  </Tooltip>
                </StyledTableCell>
              </Fragment>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  function StatusChip({ brand }) {
    let color;
    let label;
    if (brand.brand_verification_status === 0) {
      color = colors.yellow;
      label = "Unverified";
    }

    if (brand.brand_verification_status === 1) {
      color = colors.lightGreen;
      label = "Verified";
    }

    if (brand.brand_verification_status === 2) {
      color = colors.error;
      label = "Rejected";
    }

    return (
      <Chip
        style={{
          position: "relative",
          left: "-13px",
          // top: "9px",
          fontSize: "13px",
          backgroundColor: color,
          color: "#fff",
        }}
        label={label}
      />
    );
  }
}
